(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["comparison-performance"] && !Shopify.designMode) return;
  try {
    (function () {
  // Rows the sweat benchmark can actually fill. Everything else — sweetener,
  // batch testing, price — is meaningless for sweat, so those cells show a
  // dash rather than a zero that would read as a claim.
  var REFERENCE_ROWS = {
    sodium: "sodium", potassium: "potassium",
    magnesium: "magnesium", calcium: "calcium"
  };

  function initPerf(root) {
    if (root.dataset.plytPerfReady) return;

    var CELLS = window.PurelyteComparisonCells;
    if (!CELLS) return;                       // snippet not parsed yet — a later sweep retries

    var byName = {};
    var libEl = root.querySelector(".plyt-sbs__library");
    if (libEl) {
      try {
        (JSON.parse(libEl.textContent) || []).forEach(function (b) {
          if (b && b.name) byName[b.name.toLowerCase()] = b;
        });
      } catch (e) { /* malformed library — fall through to the guard below */ }
    }

    var cols = [];
    root.querySelectorAll(".plyt-perf__source[data-column]").forEach(function (n) {
      var c;
      try { c = JSON.parse(n.getAttribute("data-column")); } catch (e) { return; }
      if (!c) return;
      if (c.type === "reference") {
        c.heading = c.label || "A typical litre of sweat";
        cols.push(c);
        return;
      }
      // Matched case-insensitively, same as the side-by-side's default list:
      // an editor typing "powerade ion4" means the same brand.
      var b = byName[(c.brandName || "").toLowerCase()];
      if (!b) return;                         // named brand isn't in the library
      c.brand = b;
      // Purelyte's own column names its actual sodium source. The library
      // record says "Chloride", which is true but generic; here the point is
      // that the 800mg comes from Pink Himalayan Salt. Copied, not mutated —
      // the library record is shared with the side-by-side table.
      if (c.type === "own") {
        c.brand = Object.assign({}, b, { sodiumSource: "Pink Himalayan Salt" });
      }
      c.heading = c.label || b.name;
      cols.push(c);
    });
    if (!cols.length) return;                 // nothing to draw — leave it for a later sweep

    var order = (root.getAttribute("data-rows") || "")
      .split(",").map(function (s) { return s.trim(); }).filter(function (s) { return s.length; });
    var byKey = {};
    CELLS.ROWS.forEach(function (r) { byKey[r.key] = r; });
    var rows = order.map(function (k) { return byKey[k]; }).filter(Boolean);
    if (!rows.length) rows = CELLS.ROWS;      // unusable list — show everything rather than nothing

    root.dataset.plytPerfReady = "1";

    var grid = root.querySelector(".plyt-perf__grid");

    // Every cell is placed explicitly. This used to lean on
    // grid-auto-flow: column plus a row count set from here, and the header
    // came out as the LAST row of each column rather than the first — auto
    // flow gave no way to see why. Naming the row and column removes the
    // question: header is row 1, labels are column 1, and nothing depends on
    // the order the markup happens to be in.
    function cell(cls, col, row, body) {
      return '<div class="plyt-perf__cell ' + cls + '" style="grid-column:' + col +
        ';grid-row:' + row + '">' + body + "</div>";
    }

    grid.style.gridTemplateColumns =
      "minmax(150px, 1fr) repeat(" + cols.length + ", minmax(124px, 1fr))";

    var html = cell("plyt-perf__cell--label plyt-perf__head", 1, 1, "");
    rows.forEach(function (r, i) {
      html += cell("plyt-perf__cell--label" + (i === rows.length - 1 ? " plyt-perf__cell--last" : ""),
        1, i + 2, r.label);
    });

    cols.forEach(function (c, ci) {
      var col = ci + 2;
      var tint = c.type === "own" ? " plyt-perf__cell--own"
               : c.type === "reference" ? " plyt-perf__cell--ref" : "";

      // serveLabel is only ever the benchmark's. Its setting carries a default
      // and visible_if only hides the field in the editor — it does not stop
      // the value being stored — so every brand column was inheriting the
      // benchmark's "what you lose" line.
      var serve = c.type === "reference"
        ? (c.serveLabel || "")
        : (c.brand.serveSizeMl ? "per " + c.brand.serveSizeMl + "ml serve" : "");

      html += cell("plyt-perf__head" + tint, col, 1,
        '<span class="plyt-perf__name">' + c.heading + "</span>" +
        (serve ? '<span class="plyt-perf__serve">' + serve + "</span>" : ""));

      rows.forEach(function (r, i) {
        var body;
        if (c.type === "reference") {
          var mineral = REFERENCE_ROWS[r.key];
          body = mineral
            ? '<span class="plyt-sbs__cell-val">' + (c[mineral] || 0) + " mg</span>"
            : '<span class="plyt-sbs__no">—</span>';
        } else {
          body = r.render(c.brand);
        }
        html += cell(tint + (i === rows.length - 1 ? " plyt-perf__cell--last" : ""), col, i + 2, body);
      });
    });

    grid.innerHTML = html;
    CELLS.wireGlossary(grid);
  }

  // Same four entry points as the side-by-side, and for the same reasons: a
  // theme can render sections late, and the Section Rendering API replaces
  // markup wholesale. initPerf is idempotent, so repeating is free.
  function initAll() {
    document.querySelectorAll(".plyt-perf").forEach(initPerf);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
  window.addEventListener("load", initAll);
  document.addEventListener("shopify:section:load", initAll);
  document.addEventListener("shopify:block:select", initAll);

  if (window.MutationObserver) {
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        if (document.querySelector(".plyt-perf:not([data-plyt-perf-ready])")) initAll();
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["comparison-side-by-side"] && !Shopify.designMode) return;
  try {
    (function () {
  function highlightMatch(text, q) {
    if (!q) return text;
    var idx = text.toLowerCase().indexOf(q.toLowerCase());
    if (idx === -1) return text;
    return text.slice(0, idx) + "<strong>" + text.slice(idx, idx + q.length) + "</strong>" + text.slice(idx + q.length);
  }

  // `note` carries a per-brand caveat on the figure — a flavour that differs
  // from the rest of the range, say. It sits under the "from X" line rather
  // than beside the number, so the headline figure stays scannable.

  // Cell renderers and the row list live in
  // snippets/purelyte-comparison-cells.liquid, shared with
  // blocks/comparison-performance.liquid so there is one copy to maintain.
  //
  // Read at CALL time, never at load time. Shopify concatenates every block
  // and snippet script into one bundle and gives no ordering guarantee — this
  // block's code was placed ahead of the snippet's, so reading
  // window.PurelyteComparisonCells here threw "Cannot read properties of
  // undefined (reading 'ROWS')", killed the whole IIFE, and the table rendered
  // no brands at all. Same trap the glossary hit earlier and for the same
  // reason. initSbs bails when it's missing, and the retry sweeps pick it up.
  function cells() { return window.PurelyteComparisonCells; }
  function perLitreValue(b) { return cells().perLitreValue(b); }

  function byName(a, b) { return a.name.localeCompare(b.name); }

  // Built rather than written out: four minerals x two directions is a lot of
  // near-identical comparators to keep in step by hand. Every mineral sort
  // falls back to name, so the many brands sharing a value (0mg calcium, say)
  // land alphabetically instead of in whatever order they happened to be in.
  var SORTERS = { "name-asc": byName };
  ["sodium", "potassium", "magnesium", "calcium"].forEach(function (m) {
    SORTERS[m + "-desc"] = function (a, b) { return ((b[m] || 0) - (a[m] || 0)) || byName(a, b); };
    SORTERS[m + "-asc"] = function (a, b) { return ((a[m] || 0) - (b[m] || 0)) || byName(a, b); };
  });
  // Shared by both cost metrics so they can't drift apart. A value of 0 means
  // "can't be worked out", not "free", so it sinks to the bottom either way —
  // sorting it to the top of a "low to high" list would present unknown as the
  // best value on the table.
  function byCost(getter, desc) {
    return function (a, b) {
      var va = getter(a) || 0, vb = getter(b) || 0;
      if (!va !== !vb) return va ? -1 : 1;
      if (!va && !vb) return byName(a, b);
      return (desc ? vb - va : va - vb) || byName(a, b);
    };
  }
  function per1000Value(b) { return Number(b.pricePer1000mg) || 0; }

  SORTERS["perlitre-asc"] = byCost(perLitreValue, false);
  SORTERS["perlitre-desc"] = byCost(perLitreValue, true);
  SORTERS["per1000-asc"] = byCost(per1000Value, false);
  SORTERS["per1000-desc"] = byCost(per1000Value, true);
  SORTERS["price-asc"] = function (a, b) { return (a.pricePerServe - b.pricePerServe) || byName(a, b); };
  SORTERS["price-desc"] = function (a, b) { return (b.pricePerServe - a.pricePerServe) || byName(a, b); };


  function initSbs(root) {
    if (root.dataset.plytSbsReady) return;

    var CELLS = cells();
    if (!CELLS) return;   // snippet not parsed yet — a later sweep retries
    var ROWS = CELLS.ROWS;
    var wireGlossary = CELLS.wireGlossary;

    // Brands come from two places, merged here:
    //   1. snippets/purelyte-brand-library.liquid — the researched catalogue
    //   2. _comparison-brand child blocks — per-page additions or overrides
    // A child with the same Brand name as a library entry replaces it, so a
    // page can correct one brand without regenerating the library.
    var byName = {};
    var orderedNames = [];

    function absorb(rec) {
      if (!rec || !rec.name) return;
      if (orderedNames.indexOf(rec.name) === -1) orderedNames.push(rec.name);
      byName[rec.name] = rec;
    }

    var libEl = root.querySelector(".plyt-sbs__library");
    if (libEl) {
      try {
        (JSON.parse(libEl.textContent) || []).forEach(absorb);
      } catch (e) {
        /* a broken library shouldn't take the child blocks down with it */
      }
    }
    root.querySelectorAll(".plyt-sbs__brand[data-brand]").forEach(function (n) {
      try {
        absorb(JSON.parse(n.getAttribute("data-brand")));
      } catch (e) {
        /* skip a malformed record rather than losing the whole table */
      }
    });

    var brandsList = orderedNames.map(function (n) { return byName[n]; });
    // Bail WITHOUT marking this table done. If the library snippet or the
    // child blocks haven't landed in the DOM yet, a later sweep has to be able
    // to try again — flagging it here is what would turn a slow render into a
    // permanently empty table.
    if (!brandsList.length) return;

    // From here on the table will render, so claim it. Everything below binds
    // listeners, and a second pass over the same root would bind them twice:
    // one chip click would then toggle the filter on and straight back off,
    // which reads as "the buttons don't work" rather than as a double-init.
    root.dataset.plytSbsReady = "1";

    // "Brands shown by default" on the block wins over each record's own
    // defaultVisible flag, so a page picks its own opening columns without
    // needing a child block per brand. Matched case-insensitively on the
    // trimmed name — an editor typing "hydralyte" means the same brand, and a
    // near-miss here shows an almost-empty table with nothing to explain it.
    var defaultNames = (root.getAttribute("data-default-brands") || "")
      .split(",")
      .map(function (s) { return s.trim().toLowerCase(); })
      .filter(function (s) { return s.length; });

    var BRANDS = {};
    brandsList.forEach(function (b) { BRANDS[b.key] = b; });

    var pinnedKeys = brandsList.filter(function (b) { return b.pinned; }).map(function (b) { return b.key; });
    var visible = brandsList
      .filter(function (b) {
        if (b.pinned) return false;
        return defaultNames.length
          ? defaultNames.indexOf(b.name.toLowerCase()) !== -1
          : b.defaultVisible;
      })
      .map(function (b) { return b.key; });

    // The columns the page opens with, captured before anyone adds or removes
    // one. These keep the accent tint; brands a visitor pulls in themselves are
    // their own comparison and stay neutral, so the page's own framing is
    // visibly separate from the reader's. Removing and re-adding a default
    // brand restores its tint — it was always part of the page's argument.
    var defaultKeys = visible.slice();

    var sortSelect = root.querySelector(".plyt-sbs__sort");
    var state = { format: "All", batchOnly: false, sugarOnly: false, sort: sortSelect ? sortSelect.value : "none" };

    var table = root.querySelector(".plyt-sbs__table");
    var addInput = root.querySelector(".plyt-sbs__add-input");
    var addPanel = root.querySelector(".plyt-sbs__add-panel");
    var batchToggle = root.querySelector("[data-batch-toggle]");
    var sugarToggle = root.querySelector("[data-sugar-toggle]");

    // Format chips are built here, from the same JSON the table renders off,
    // rather than in Liquid off block.blocks — reading a child block's
    // .settings from the parent is unreliable in this theme (it silently
    // returned nothing, so the chips never appeared). Anything derived from
    // the brand list belongs on this side of the fence.
    var formatGroup = root.querySelector("[data-format-group]");
    var chipRow = root.querySelector(".plyt-sbs__chip-row");
    var formats = [];
    brandsList.forEach(function (b) {
      if (b.format && formats.indexOf(b.format) === -1) formats.push(b.format);
    });
    if (chipRow && formats.length > 1) {
      var chipHtml = '<button class="plyt-sbs__chip" type="button" data-format="All" aria-pressed="true">All</button>';
      formats.forEach(function (f) {
        chipHtml += '<button class="plyt-sbs__chip" type="button" data-format="' + f + '" aria-pressed="false">' + f + "</button>";
      });
      chipRow.innerHTML = chipHtml;
      if (formatGroup) formatGroup.hidden = false;
    }
    var chips = root.querySelectorAll(".plyt-sbs__chip");

    if (sortSelect) {
      sortSelect.addEventListener("change", function () {
        state.sort = sortSelect.value;
        render();
      });
    }

    chips.forEach(function (chip) {
      chip.addEventListener("click", function () {
        state.format = chip.getAttribute("data-format");
        chips.forEach(function (c) { c.setAttribute("aria-pressed", c === chip ? "true" : "false"); });
        render();
      });
    });

    if (batchToggle) {
      batchToggle.addEventListener("click", function () {
        state.batchOnly = !state.batchOnly;
        batchToggle.setAttribute("aria-pressed", String(state.batchOnly));
        render();
      });
    }

    if (sugarToggle) {
      sugarToggle.addEventListener("click", function () {
        state.sugarOnly = !state.sugarOnly;
        sugarToggle.setAttribute("aria-pressed", String(state.sugarOnly));
        render();
      });
    }

    function openAddPanel() {
      renderAddPanel(addInput.value.trim());
      addPanel.hidden = false;
      addInput.setAttribute("aria-expanded", "true");
    }
    function closeAddPanel() {
      addPanel.hidden = true;
      addInput.setAttribute("aria-expanded", "false");
    }
    function selectBrand(k) {
      visible.push(k);
      addInput.value = "";
      closeAddPanel();
      render();
      addInput.focus();
    }

    addInput.addEventListener("focus", openAddPanel);
    addInput.addEventListener("input", openAddPanel);
    addInput.addEventListener("keydown", function (e) {
      if (e.key === "Escape") { closeAddPanel(); addInput.blur(); return; }
      if (e.key === "Enter") {
        e.preventDefault();
        var active = addPanel.querySelector("button.plyt-sbs__add-active");
        if (active) selectBrand(active.getAttribute("data-key"));
        return;
      }
      if (e.key === "ArrowDown" || e.key === "ArrowUp") {
        e.preventDefault();
        var btns = addPanel.querySelectorAll("button[data-key]");
        if (!btns.length) return;
        var idx = -1;
        for (var i = 0; i < btns.length; i++) { if (btns[i].classList.contains("plyt-sbs__add-active")) idx = i; }
        for (var j = 0; j < btns.length; j++) { btns[j].classList.remove("plyt-sbs__add-active"); }
        idx = e.key === "ArrowDown" ? (idx + 1) % btns.length : (idx - 1 + btns.length) % btns.length;
        btns[idx].classList.add("plyt-sbs__add-active");
        btns[idx].scrollIntoView({ block: "nearest" });
      }
    });
    document.addEventListener("click", function (e) {
      if (e.target !== addInput && !addPanel.contains(e.target)) closeAddPanel();
    });
    addPanel.addEventListener("click", function (e) { e.stopPropagation(); });

    // Does this brand survive the filters currently applied to the table?
    // The search obeys them for a practical reason: a brand added while it
    // fails a filter gets dropped from cols on the very next render, so the
    // click would look like it did nothing.
    function passesFilters(b) {
      if (state.format !== "All" && b.format !== state.format) return false;
      if (state.batchOnly && !b.batchTested) return false;
      // Reads the zeroSugar flag rather than testing the Sugar figure, because
      // that figure covers sugar AND high-GI carbs in one number. Seven brands
      // sit under 1g while naming no added sugar at all — Thorzt's 0.8g is
      // declared maltodextrin — so they carry no sugar even though the cell
      // isn't 0g. The flag is worked out per brand where the label can be read.
      if (state.sugarOnly && !b.zeroSugar) return false;
      return true;
    }

    // "Tub", "zero sugar", "Tub, zero sugar, batch tested" — or "" unfiltered.
    function filterLabel() {
      var bits = [];
      if (state.format !== "All") bits.push(state.format);
      if (state.sugarOnly) bits.push("zero sugar");
      if (state.batchOnly) bits.push("batch tested");
      return bits.join(", ");
    }

    function addNote(text) {
      var el = document.createElement("div");
      el.className = "plyt-sbs__add-empty";
      el.textContent = text;
      addPanel.appendChild(el);
    }

    function renderAddPanel(query) {
      addPanel.innerHTML = "";
      var scope = filterLabel();

      var inScope = brandsList.filter(function (b) {
        return pinnedKeys.indexOf(b.key) === -1 && passesFilters(b);
      });
      var remaining = inScope.filter(function (b) { return visible.indexOf(b.key) === -1; });

      if (!inScope.length) {
        addNote("No " + scope + " brands in the library.");
        return;
      }
      if (!remaining.length) {
        addNote(scope
          ? "Every " + scope + " brand is already on the table."
          : "Every researched brand is already on the table.");
        return;
      }

      var matches = remaining.filter(function (b) {
        return b.name.toLowerCase().indexOf(query.toLowerCase()) !== -1;
      });
      if (!matches.length) {
        addNote(scope
          ? 'No ' + scope + ' brand matches "' + query + '".'
          : 'No researched brand matches "' + query + '".');
        return;
      }

      // Say why the list is short, so a filtered search doesn't read as broken.
      if (scope) {
        var hint = document.createElement("div");
        hint.className = "plyt-sbs__add-scope";
        hint.textContent = "Showing " + scope + " only";
        addPanel.appendChild(hint);
      }

      matches.forEach(function (b, i) {
        var btn = document.createElement("button");
        btn.type = "button";
        btn.setAttribute("data-key", b.key);
        if (i === 0) btn.classList.add("plyt-sbs__add-active");
        btn.innerHTML = "<span>" + highlightMatch(b.name, query) + "</span><small>" + b.format + "</small>";
        btn.addEventListener("click", function () { selectBrand(b.key); });
        addPanel.appendChild(btn);
      });
    }

    function removeBrand(k) {
      visible = visible.filter(function (x) { return x !== k; });
      render();
    }

    function render() {
      // Same predicate the "Add a brand" search uses, so the two can't drift
      // and offer something the table would immediately hide.
      var cols = visible.filter(function (k) { return passesFilters(BRANDS[k]); });
      if (SORTERS[state.sort]) {
        cols = cols.sort(function (ka, kb) { return SORTERS[state.sort](BRANDS[ka], BRANDS[kb]); });
      }
      cols = pinnedKeys.concat(cols);

      // Purelyte's column carries the brand blue, the page's own default
      // competitors carry the orange accent, and anything the visitor added
      // gets no tint at all.
      function tint(k) {
        if (BRANDS[k].pinned) return "plyt-sbs__own";
        return defaultKeys.indexOf(k) !== -1 ? "plyt-sbs__focus" : "";
      }

      var thead = "<thead><tr><th class=\"plyt-sbs__rowlabel\"></th>";
      cols.forEach(function (k) {
        var b = BRANDS[k];
        thead += '<th class="' + tint(k) + '"><span class="plyt-sbs__th-inner">' + b.name +
          (b.pinned ? "" : '<button class="plyt-sbs__rm" type="button" data-remove="' + k + '" aria-label="Remove ' + b.name + '">&times;</button>') +
          "</span></th>";
      });
      thead += "</tr></thead>";

      var tbody = "<tbody>";
      ROWS.forEach(function (row) {
        tbody += '<tr><td class="plyt-sbs__rowlabel">' + row.label + "</td>";
        cols.forEach(function (k) {
          tbody += '<td class="' + tint(k) + '">' + row.render(BRANDS[k]) + "</td>";
        });
        tbody += "</tr>";
      });
      tbody += "</tbody>";

      table.innerHTML = thead + tbody;

      table.querySelectorAll("[data-remove]").forEach(function (btn) {
        btn.addEventListener("click", function () { removeBrand(btn.getAttribute("data-remove")); });
      });

      wireGlossary(table);

      // If the search is open when a filter changes, re-scope it in place
      // rather than leaving a stale list behind.
      if (addPanel && !addPanel.hidden) renderAddPanel(addInput.value.trim());
    }

    render();
  }

  // ---------------------------------------------------------------------
  // Bootstrap. This used to be a single DOMContentLoaded pass, which is only
  // correct if the table is in the DOM by then and never replaced. Neither
  // holds: a theme that renders below-the-fold sections lazily can add this
  // block afterwards, and the Section Rendering API swaps section markup
  // wholesale, taking the initialised table with it. Both leave an empty
  // table with no error — the table is built entirely in JS, so nothing
  // renders server-side to fall back on. Hence four entry points, all
  // idempotent via the flag in initSbs.
  // ---------------------------------------------------------------------
  function initAll() {
    document.querySelectorAll(".plyt-sbs").forEach(initSbs);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  // Late DOM: lazily rendered sections, and the case where this script ran
  // before the library snippet's JSON was parsed.
  window.addEventListener("load", initAll);

  // Theme editor, and any theme feature that re-renders a section.
  document.addEventListener("shopify:section:load", initAll);
  document.addEventListener("shopify:block:select", initAll);

  // Catch-all for markup inserted after load with no event to hang off.
  // Cheap: one querySelector per animation frame, and only when something
  // actually changed and an uninitialised table is present.
  if (window.MutationObserver) {
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        if (document.querySelector(".plyt-sbs:not([data-plyt-sbs-ready])")) initAll();
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
  } catch(e) { console.error(e); }
})();

})();
